import anabelPic from "@/public/images/artists/anabel.png";
import { Artist } from "@/types/types";

export const anabel = {
  id: "150",
  name: "Anabel",
  image: anabelPic,
  description: `Anabel's voice carries a classic jazz charm with a touch of old-world elegance. Her sound is smooth and evocative, blending sophistication with a warm, nostalgic quality.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fanabel-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Jazz", "Soundtrack", "Falsetto"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Very high",
      },
      specific: {
        low: 48,
        high: 74,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
